import { render, staticRenderFns } from "./Nagios.vue?vue&type=template&id=dca01d16&scoped=true&"
import script from "./Nagios.vue?vue&type=script&lang=js&"
export * from "./Nagios.vue?vue&type=script&lang=js&"
import style0 from "./Nagios.vue?vue&type=style&index=0&id=dca01d16&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca01d16",
  null
  
)

export default component.exports